import loadable from '@loadable/component';

const NotFound = loadable(() => import('./components'), {
  resolveComponent: module => module.Router,
});

export { NotFound };
